<template>
  <li class="kt-menu__item">
    <v-hover>
      <a @click="openLink" class="kt-menu__link" href="javascript:">
        <span class="kt-menu__link-icon"></span>
        <span class="kt-menu__link-text">{{ course.name }}</span>
      </a>
    </v-hover>
  </li>
</template>

<script>
export default {
  name: 'AsideScormCourses',
  props: ['course'],
  methods: {
    openLink() {
      this.$router.push({
        name: 'UnitPage',
        params: {
          id: this.course.id,
        },
      });
      this.$store.dispatch('app/setMenuState', false);
    },
  },
};
</script>

<style scoped></style>
